export const PAGE_NOT_FOUND = 'not-found';
export const PAGE_PORTAIL_CLIENT = 'portailClient';
export const PAGE_RECOM = 'recom';
